import CryptoES from 'crypto-es';
import { put, call } from 'redux-saga/effects';

import { logIn } from '@api/auth';
import { API_STATUS_AUTH_CODE_SENT } from '@constants/general';
import { setUser } from '@helpers/user';
import { history, vsuiteRoutes } from '@routes';
import { getUserDetailsSaga } from '@sagas/user/getUserDetailsSaga';
import { setLoginToken, reset } from '@store/auth/auth.reducer';
import { toastError } from '@store/notifications';

export const loginSaga = function* ({
  payload: {
    data: { email, password },
    setErrors,
    setSubmitting,
    returnTo,
  },
}) {
  try {
    if (!email || !password) return;
    const hashedPassword = CryptoES.SHA512(password).toString(CryptoES.enc.Hex);

    const response = yield call(logIn, email, hashedPassword);

    const { status, token, needs2faSetup, user, refresh } = response;

    if (status === API_STATUS_AUTH_CODE_SENT) {
      // have 2FA setup and code has been sent
      yield call(history.push, vsuiteRoutes.TWO_FACTOR_AUTH.make());
    }

    if (token && !needs2faSetup && user?.id) {
      // 2FA not required, login
      yield put(reset());
      yield call(setUser, { id: user.id, token, refresh });
      yield call(getUserDetailsSaga, {
        payload: {
          userId: user.id,
        },
      });
      yield call(history.push, returnTo || vsuiteRoutes.DASHBOARD.make());
    } else if (token && needs2faSetup) {
      // Requires 2FA setup. Store token in store
      yield put(setLoginToken(token));
      yield call(history.push, vsuiteRoutes.TWO_FACTOR_AUTH_SETUP.make());
    }
  } catch (error) {
    const { fieldErrors, nonFieldErrors, hasNonFieldError, hasFieldError } = error.data || {};

    if (hasFieldError) {
      yield call(setErrors, fieldErrors);
    }

    yield put(
      toastError({
        message: hasNonFieldError
          ? nonFieldErrors
          : {
              defaultMessage: 'Login request failed.',
              id: 'components.login-form.response.failure',
            },
      })
    );

    yield call(setSubmitting, false);
  }
};
